// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'

// Internal Dependencies:
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
import Link from 'church-theme-library/components/Link/Link'
import PostSectionB from 'church-theme-library/components/PostSections/PostSectionB'
import { get, loop } from 'church-theme-library/utilities/objects'

// Redux:
import { getVideosData } from 'church-theme-library/redux/actions/site'

class VideosLayout extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		// window.scrollTo( 0, 0 )
		window.scrollTo( { top: 0, behavior: 'smooth' } )

		dispatch( getVideosData() )
	}

	renderSections() {
		const { type, videos, locale, slugs } = this.props
		const sections = get( ['sections'] )( videos )
		let posts = []

		if ( ! sections || ! Object.keys( sections ).length ) {
			return null
		}

		loop( sections, ( key, item ) => {
			posts.push( {
				is_external: true,
				id: item.id,
				title: item.title,
				slug: item.id,
				url: `/${slugs.videos}/${slugs.category}/${item.id}`,
				featured_image: false
			} )
		} )

		return (
			<div className="wide-sections">
				{ !! posts.length &&
					<PostSectionB type={ type } posts={ posts } showDateSelect={ false } disableLoadMorePosts={ true } showDeleteButton={ false } />
				}
			</div>
		)
	}

	renderPlaylists() {
		const { type, videos, locale, slugs } = this.props
		const playlists = get( ['playlists'] )( videos )
		let posts = []

		if ( ! playlists || ! Object.keys( playlists ).length ) {
			return null
		}

		loop( playlists, ( key, item ) => {
			posts.push( {
				is_external: true,
				id: item.id,
				title: item.title,
				slug: item.id,
				url: `/${slugs.videos}/${slugs.category}/${item.id}`,
				featured_image: {
					url: get( ['thumbnail', 'url'] )( item ),
					width: get( ['thumbnail', 'width'] )( item ),
					height: get( ['thumbnail', 'height'] )( item ),
					alt: ''
				}
			} )
		} )

		return (
			<div className="wide-sections">
				{ !! posts.length &&
					<PostSectionB type={ type } posts={ posts } showDateSelect={ false } disableLoadMorePosts={ true } showDeleteButton={ false } />
				}
			</div>
		)
	}

	render() {
		const { type, page, isLoading, loadingById, videosReceived, match } = this.props
		const { params } = match
		const hasCorrectPageData = ( page && params.slug == page.slug )
		let showLoading = ! hasCorrectPageData || ! videosReceived

		if ( isLoading ) {
			return null
		}

		return (
			<div>
				<div className="main-inner">
					{ showLoading &&
						<LoadingSpinner />
					||
						this.renderPlaylists()
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		isLoading: state.page.isLoading,
		loadingById: state.page.loadingById,
		videos: state.site.videos,
		videosReceived: state.site.videosReceived,
		youtubeURL: state.site.youtubeURL,
		locale: state.site.locale,
		slugs: state.site.slugs
	}
}

export default connect( mapStateToProps )( VideosLayout )
